module.exports = "/images/training_list_thumb.png?bcfe7171d806b1deb7f1061ea3442810";